
export const roles = {
  label: "Roles",
  type: "array",
  items: {
    type: "string",
    default: "",
  },
  default: [],
  widget: "tags",
};

export const keyId = {
  label: "API Key ID",
  type: "string",
};

// What the key is for, in the owner's words. keyId is opaque and the secret is
// shown once, so this is the only thing that tells two keys apart in the list.
// Stored by auth-repoflow with the rest of the key — pagews keeps no key rows.
export const description = {
  label: "Description",
  type: "string",
};

// The site an `agent` key is bound to (docs/pagews.md §Site-scoped keys), read
// off its `scope` — shown in the keys list and a key's view.
export const siteId = {
  label: "Site",
  type: "string",
};

// What an `agent` key is bound to (docs/scoped-keys.md): here always
// `{ service: "pagews", type: "site", id: <siteId> }`, the one kind pagews
// enforces. Free text in the form: that the site is this organization's, and
// that the scope is a pagews site at all, is checked by model/key.create, and
// that the roles fit it by auth-repoflow. All empty is no scope.
export const scope = {
  label: "Scope",
  type: "object",
  properties: {
    service: { label: "Service", type: "string" },
    type: { label: "Type", type: "string" },
    id: { label: "Id", type: "string" },
  },
};

export const keySecret = {
  type: "string",
};

